class ImageAndProducts extends HTMLElement {
  constructor() {
    super();

    this.isTicking = false;

    this.requestTick = this.requestTick.bind(this);
    this.updateEl = this.updateEl.bind(this);
    this.onScroll = this.onScroll.bind(this);

    this.lastScrollY = window.scrollY
    this.scrollDirection = "down";

    this.setupListeners();
  }

  setupListeners() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onScroll, { passive: true });

    this.requestTick();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onScroll);
  }

  onScroll() {
    const currentScrollY = window.scrollY;

    if (currentScrollY > this.lastScrollY) {
      this.scrollDirection = "down";
    } else {
      this.scrollDirection = "up";
    }

    this.lastScrollY = currentScrollY;

    this.requestTick();
  }

  requestTick() {
    if (!this.isTicking) requestAnimationFrame(this.updateEl);
    this.isTicking = true;
  }

  updateEl() {
    this.isTicking = false;
    this.setSticky();
  }

  setSticky() {
    const columnsEl = this.querySelector('.sec-ImageAndProducts_Columns');
    const stickyHeader = this.querySelector('.sec-ImageAndProducts_StickyHeader')
    if (!columnsEl && !stickyHeader) return;

    const isMobile = window.innerWidth < 768;

    if (!isMobile) {
      this.isSticky = false;
      return;
    }

    const stickyOffset =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue("--header-height")
      ) || 0;

    const stickyHeaderHeight =
      parseFloat(
        getComputedStyle(this).getPropertyValue("--image-and-products-sticky-height")
      ) || 75;

    const sectionRect = this.getBoundingClientRect();
    const headerRect = columnsEl.getBoundingClientRect();

    const shouldStartSticky = headerRect.top <= 30;

    const layoutJump = stickyHeaderHeight;

    const endThresholdHide = stickyOffset + stickyHeaderHeight + 8;
    const endThresholdShow = endThresholdHide + layoutJump + 10;

    const shouldStopSticky = this.isSticky
      ? sectionRect.bottom <= endThresholdHide
      : sectionRect.bottom <= endThresholdShow;

    // if scroll up add stickyHeaderHeight to stickyHeader el
    if(this.scrollDirection === "up") {
      stickyHeader.style.top = `${stickyOffset}px`;
    } else {
      stickyHeader.style.top = "0";
    }

    this.isSticky = shouldStartSticky && !shouldStopSticky;
  }

  get isSticky() {
    return this.hasAttribute("stuck");
  }

  set isSticky(val) {
    val ? this.setAttribute("stuck", "") : this.removeAttribute("stuck");
  }
}

if (!customElements.get("image-and-products")) {
  customElements.define("image-and-products", ImageAndProducts);
}
